module.exports = __webpack_public_path__ + "img/89.255a46a1.jpg";